import { render, staticRenderFns } from "./returnsList.vue?vue&type=template&id=d0070ce6"
import script from "./returnsList.vue?vue&type=script&lang=js"
export * from "./returnsList.vue?vue&type=script&lang=js"
import style0 from "./returnsList.vue?vue&type=style&index=0&id=d0070ce6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports